'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = UIMain;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Main body of the app. There should only be one per application.
 *
 * @category Layout
 */

function UIMain(_ref) {
  var className = _ref.className,
      children = _ref.children,
      flush = _ref.flush,
      use = _ref.use,
      other = _objectWithoutProperties(_ref, ['className', 'children', 'flush', 'use']);

  var classes = (0, _classNames2.default)('private-main', className, {
    'private-main--flush': flush,
    'private-main--dark': use === 'dark'
  });

  return _react2.default.createElement(
    'main',
    _extends({}, other, { className: classes }),
    children
  );
}

UIMain.propTypes = {
  children: _react.PropTypes.node.isRequired,
  flush: _react.PropTypes.bool,
  use: _react.PropTypes.oneOf(['standard', 'dark'])
};

UIMain.displayName = 'UIMain';
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2750/js/layout/UIMain.js
// module id = 597
// module chunks = 171